export default "__VITE_ASSET__Dhrq_sTB__"